// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"636":"16377c51e7eaf024","1836":"16377c51e7eaf024"}[chunkId] + ".css";
};